import { z } from "zod";
function brandedUuid() {
    return z
        .string()
        .uuid()
        .transform((value) => value);
}
export const tenantIdSchema = brandedUuid();
export const memberIdSchema = brandedUuid();
export const connectionIdSchema = brandedUuid();
export const syncRunIdSchema = brandedUuid();
export const sourceItemIdSchema = brandedUuid();
export const sourceIdSchema = sourceItemIdSchema;
export const sourceTextPayloadIdSchema = brandedUuid();
export const extractionManifestIdSchema = brandedUuid();
export const documentIdSchema = brandedUuid();
export const documentVersionIdSchema = brandedUuid();
export const documentBlockIdSchema = brandedUuid();
export const processingJobIdSchema = brandedUuid();
export const entityIdSchema = brandedUuid();
export const identifierIdSchema = brandedUuid();
export const aliasIdSchema = brandedUuid();
export const claimIdSchema = brandedUuid();
export const eventIdSchema = brandedUuid();
export const relationIdSchema = brandedUuid();
export const evidenceIdSchema = brandedUuid();
export const knowledgeProcessingResultIdSchema = brandedUuid();
export const resolvedFactIdSchema = brandedUuid();
export const observedStateIdSchema = brandedUuid();
export const knowledgeProjectionIdSchema = brandedUuid();
export const visibilityRuleIdSchema = brandedUuid();
//# sourceMappingURL=ids.js.map